import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from '../../api/axios';
import { AutoComplete } from 'primereact/autocomplete';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import priceTierService from "../../services/PriceTierService";
import productService from "../../services/ProductService";

export default function ProductsEditPage() {

  const navigate = useNavigate();
  const { id } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const toast = useRef(null);

  // FORM STATES
  const [name, setName] = useState('');
  const [brandName, setBrandName] = useState('');
  const [tags, setTags] = useState('');

  const [salePrice, setSalePrice] = useState(null);
  const [salePriceIsVatIncluded, setSalePriceIsVatIncluded] = useState(false);
  const [taxRate, setTaxRate] = useState(20);

  const [calcExclVat, setCalcExclVat] = useState(null);
  const [calcInclVat, setCalcInclVat] = useState(null);
  const [currentStockQuantity, setCurrentStockQuantity] = useState(0);

  const [barcode, setBarcode] = useState('');
  const [unit, setUnit] = useState('');
  const [unitType, setUnitType] = useState(null);
  const [trackExpirationDate, setTrackExpirationDate] = useState(false);
  const [criticalStockQuantity, setCriticalStockQuantity] = useState(0);
  const [description, setDescription] = useState('');
  const [recordStatus, setRecordStatus] = useState(1);

  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [category, setCategory] = useState(null);
  
  const [priceTiers, setPriceTiers] = useState([]);
  const [tierPrices, setTierPrices] = useState({});

  const [loading, setLoading] = useState(true);

  const [categoryIdFromDb, setCategoryIdFromDb] = useState(null);
 
const [unitTypes, setUnitTypes] = useState([]);
const [filteredUnitTypes, setFilteredUnitTypes] = useState([]);
const [unitTypeIdFromDb, setUnitTypeIdFromDb] = useState(null);

  const [originalSalePriceInclVat, setOriginalSalePriceInclVat] = useState(0);
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [showInvoicesDialog, setShowInvoicesDialog] = useState(false);
  const [openInvoices, setOpenInvoices] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);

useEffect(() => {
  api.get(apiUrl + "Lookups/unit-types")
    .then(res => {
      const arr = res.data?.data ?? res.data ?? []; 
      const list = arr.map(x => ({
        label: x.name,   
        value: x.id    
      }));

      setUnitTypes(list);
      setFilteredUnitTypes(list);
    })
    .catch(() => {});
}, [apiUrl]);
const searchUnitType = (e) => {
  const q = (e.query || "").toLowerCase();
  const filtered = unitTypes.filter(u =>
    (u.label || "").toLowerCase().includes(q)
  );
  setFilteredUnitTypes(filtered);
};
  const filterItems = (arr = [], query = "") =>
    arr.filter(item => (item.label || "").toLowerCase().includes((query || "").toLowerCase()));

  const searchCategory = (e) => {
  const filtered = filterItems(categories, e.query);
  setFilteredCategories(enrichCategories(filtered, e.query));
  };
  
  const [lastPurchase, setLastPurchase] = useState(null);
  // KDV HESABI
  const recalcVatValues = (price = salePrice, vat = taxRate, included = salePriceIsVatIncluded) => {
    if (price == null || vat == null) return;

    let excl, incl;

    if (included) {
      incl = price;
      excl = price / (1 + vat / 100);
    } else {
      excl = price;
      incl = price * (1 + vat / 100);
    }

    setCalcExclVat(excl);
    setCalcInclVat(incl);
  }; 

 useEffect(() => {
  if (unitTypeIdFromDb != null && unitTypes.length > 0) {
    const idNum = Number(unitTypeIdFromDb);
    const match = unitTypes.find(u => u.value === idNum);
    if (match) setUnitType(match);
  }
}, [unitTypeIdFromDb, unitTypes]);

  // 🔥 ÜRÜN DETAYINI ÇEK
  useEffect(() => {
    const loadProduct = async () => {
      try {
        // Fetch all price tiers
        try {
          const tiersRes = await priceTierService.getAll();
          setPriceTiers(tiersRes.data?.data ?? tiersRes.data ?? []);
        } catch (tierErr) {
          console.error("Fiyat seviyeleri alınamadı", tierErr);
        }

        // Fetch product detail
        const res = await api.get(apiUrl + `product/get-product/${id}`);
        const d = res.data.data; 
        setLastPurchase(d.lastPurchase ?? null);
        setName(d.name ?? '');
        setBrandName(d.brandName ?? '');
        setTags(d.tags ?? '');

        const isInc = d.salePriceIsVatIncluded ?? false;
        setSalePriceIsVatIncluded(isInc);

        const excl = d.salePriceExclVat ?? 0;
        const incl = d.salePriceInclVat ?? 0;

        // UI fiyatı
        setSalePrice((excl==0 || isInc ) ? incl : excl);
 
        // Hesaplanan fiyatlar
        setCalcExclVat(excl);
        setCalcInclVat(incl);
        setOriginalSalePriceInclVat(incl);
        setCurrentStockQuantity(d.currentStockQuantity ?? 0);

        setTaxRate(d.taxRate ?? 20);
        setBarcode(d.barcode ?? '');
        setUnit(d.unit ?? '');

        setUnitTypeIdFromDb(d.unitTypeId ?? d.unitType ?? null);

        setCriticalStockQuantity(d.criticalStockQuantity ?? 0);
        setTrackExpirationDate(d.trackExpirationDate ?? false);
        setDescription(d.description ?? '');
        setRecordStatus(d.recordStatus ?? 1);

        setCategoryIdFromDb(d.categoryId);

        // Fetch existing prices for price tiers
        try {
          const pricesRes = await productService.getPrice(id);
          const alternatives = pricesRes.data?.priceAlternatives ?? [];
          const initialTierPrices = {};
          alternatives.forEach(alt => {
            initialTierPrices[alt.priceTierId] = { priceInclVat: alt.priceInclVat };
          });
          setTierPrices(initialTierPrices);
        } catch (pricesErr) {
          console.error("Ürün fiyat alternatifleri alınamadı", pricesErr);
        }
 
      } catch (err) {
        console.error(err);
        toast.current?.show({
          severity: 'error',
          summary: 'Hata',
          detail: 'Ürün bulunamadı.',
          life: 3000
        });
      } finally {
        setLoading(false);
      }
    };

    loadProduct();
  }, [apiUrl, id]);

  // 🔥 KATEGORİLERİ ÇEK
  useEffect(() => {
    api.get(apiUrl + 'Category/combo-categories')
      .then(res => {
        const list = (res.data || []).map(x => ({
        label: x.label ?? x.name ?? x.text,   // hangisi geliyorsa
        value: x.value ?? x.id
      }));
        setCategories(list);
        setFilteredCategories(list);
      })
      .catch(() => {});
  }, [apiUrl]);
 
const enrichCategories = (list = [], query = "") => {
  if (!query) return list;

  const exists = list.some(
    c => c.label.toLowerCase() === query.toLowerCase()
  );

  if (!exists) {
    return [
      ...list,
      {
        label: `"${query}" adlı yeni kategori ekle`,
        value: "__create__",
        rawName: query,
        isCreate: true
      }
    ];
  }

  return list;
};

useEffect(() => {
  if (categoryIdFromDb && categories.length > 0) {
    const match = categories.find(c => c.value === categoryIdFromDb);
    if (match) setCategory(match);
  }
}, [categoryIdFromDb, categories]);

  // 🔥 KDV hesaplamasını initial yüklemede 1 kez yap
  useEffect(() => {
    if (loading) return;
    if (salePrice != null) {
      recalcVatValues(salePrice, taxRate, salePriceIsVatIncluded);
    }
  }, [loading]);

  const saveProductOnly = async () => {
    let excl = calcExclVat;
    let incl = calcInclVat;

    // son güvenlik için hesapla
    if (salePrice != null && taxRate != null) {
      if (salePriceIsVatIncluded) {
        incl = salePrice;
        excl = salePrice / (1 + taxRate / 100);
      } else {
        excl = salePrice;
        incl = salePrice * (1 + taxRate / 100);
      }
    }

    const payload = {
      productDto: {
        Id: parseInt(id),
        Name: name,
        BrandName: brandName,
        CategoryId: category?.value,
        Tags: tags,
        SalePrice: salePrice,
        SalePriceIsVatIncluded: salePriceIsVatIncluded,
        TaxRate: taxRate,
        Barcode: barcode,
        Unit: unit,
        UnitTypeId: unitType?.value, 
        CriticalStockQuantity: criticalStockQuantity,
        CurrentStockQuantity: currentStockQuantity,
        TrackExpirationDate: trackExpirationDate,
        Description: description,
        RecordStatus: recordStatus,
        TenantId: 1,
        UserId: 1
      }
    };

    await api.post(apiUrl + "product/update", payload);
    
    // Alternatif fiyatları kaydet
    const pricesPayload = Object.keys(tierPrices).map(tierId => {
      const incl = tierPrices[tierId]?.priceInclVat ?? 0;
      const excl = incl / (1 + taxRate / 100);
      return {
        priceTierId: parseInt(tierId),
        priceInclVat: incl,
        priceExclVat: excl
      };
    });

    await productService.savePrices(parseInt(id), pricesPayload);
  };

  // UPDATE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    let incl = calcInclVat;
    if (salePrice != null && taxRate != null) {
      if (salePriceIsVatIncluded) {
        incl = salePrice;
      } else {
        incl = salePrice * (1 + taxRate / 100);
      }
    }

    const priceChanged = Math.abs(incl - originalSalePriceInclVat) > 0.001;

    if (priceChanged) {
      try {
        const resInvoices = await productService.getOpenInvoicesByProduct(id);
        const invoices = resInvoices.data?.data ?? [];
        if (invoices.length > 0) {
          setOpenInvoices(invoices);
          setSelectedInvoices(invoices.map(x => x.saleId));
          setShowWarningDialog(true);
          return;
        }
      } catch (err) {
        console.error("Açık faturalar kontrol edilemedi", err);
      }
    }

    // Normal güncelleme (fiyat değişmediyse ya da açık fatura yoksa)
    try {
      await saveProductOnly();
      toast.current.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Ürün güncellendi.',
        life: 2500
      });
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Hata: " + (err.response?.data?.message || err.message));
    }
  };

  const handleUpdateProductOnly = async () => {
    try {
      await saveProductOnly();
      toast.current.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Ürün güncellendi.',
        life: 2500
      });
      setShowWarningDialog(false);
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Hata: " + (err.response?.data?.message || err.message));
    }
  };

  const handleToggleAll = () => {
    if (selectedInvoices.length === openInvoices.length) {
      setSelectedInvoices([]);
    } else {
      setSelectedInvoices(openInvoices.map(x => x.saleId));
    }
  };

  const handleToggleInvoice = (saleId) => {
    if (selectedInvoices.includes(saleId)) {
      setSelectedInvoices(prev => prev.filter(id => id !== saleId));
    } else {
      setSelectedInvoices(prev => [...prev, saleId]);
    }
  };

  const handleUpdateWithInvoices = async () => {
    try {
      await saveProductOnly();

      if (selectedInvoices.length > 0) {
        let incl = calcInclVat;
        if (salePrice != null && taxRate != null) {
          if (salePriceIsVatIncluded) {
            incl = salePrice;
          } else {
            incl = salePrice * (1 + taxRate / 100);
          }
        }
        await productService.updateOpenInvoicesProductPrice({
          productId: parseInt(id),
          newPrice: incl,
          selectedSaleIds: selectedInvoices
        });
      }

      toast.current.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Ürün ve seçilen faturalar güncellendi.',
        life: 2500
      });
      setShowInvoicesDialog(false);
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Hata: " + (err.response?.data?.message || err.message));
    }
  };

  const handleUpdateProductOnlyFromList = async () => {
    try {
      await saveProductOnly();
      toast.current.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Ürün güncellendi (faturalar güncellenmedi).',
        life: 2500
      });
      setShowInvoicesDialog(false);
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Hata: " + (err.response?.data?.message || err.message));
    }
  };

  if (loading) return <Card><p>Yükleniyor...</p></Card>;

  return (
    <>
      {/* TASARIM CSS */}
      <style>
        {`
          body { background-color: #f5f6fa !important; }
          .dark body { background-color: #0f172a !important; }
          .section-container { display: flex; gap: 20px; margin-bottom: 20px; }
          .section-box { flex: 1; padding: 20px; border-radius: 12px; background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.06); border: 1px solid #e2e8f0; }
          .dark .section-box { background: #1e293b !important; border-color: #334155 !important; box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important; }
          .section-header { font-size: 1.05rem; font-weight: 700; margin-bottom: 15px; color: #334155; display: flex; align-items: center; }
          .dark .section-header { color: #ffffff !important; }
          .section-header i { font-size: 1.3rem; margin-right: 10px; color: #6366f1; }
          .field-item { margin-bottom: 16px; display: flex; flex-direction: column; }
          .field-label { font-size: .85rem; font-weight: 600; margin-bottom: 6px; color: #475569; }
          .dark .field-label { color: #cbd5e1 !important; }
        `}
      </style>

      <Card
        title={
          <div className="flex justify-content-between align-items-center">
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>Ürün Düzenle</span>
            <div className="flex gap-2">
              <Button label="Geri" icon="pi pi-arrow-left" className="p-button-secondary" onClick={() => navigate("/products")} />
              <Button form="product-form" label="Güncelle" icon="pi pi-check" className="p-button-success" type="submit" />
            </div>
          </div>
        }
      >
        <Toast ref={toast} />

        <form id="product-form" onSubmit={handleSubmit}>
          <div className="section-container">

            {/* 1. BÖLÜM */}
            <div className="section-box">
              <div className="section-header"><i className="pi pi-box"></i> Ürün Bilgileri</div>

              <div className="field-item">
                <label className="field-label">Ürün Adı</label>
                <InputText value={name} onChange={(e) => setName(e.target.value)} required />
              </div>

              <div className="field-item">
                <label className="field-label">Marka</label>
                <InputText value={brandName} onChange={(e) => setBrandName(e.target.value)} />
              </div>

              <div className="field-item">
                <label className="field-label">Kategori</label>
                <AutoComplete
  value={category}
  suggestions={filteredCategories}
  completeMethod={searchCategory}
  field="label"
  dropdown
  appendTo={document.body}
  itemTemplate={(item) =>
  item.isCreate ? (
    <div className="flex items-center gap-2 text-blue-600 font-bold">
      <i className="pi pi-plus-circle"></i>
      {item.label}
    </div>
  ) : (
    <span>{item.label}</span>
  )
}
  onChange={async (e) => {
    const selected = e.value;

    // 🆕 Yeni kategori ekleme
    if (selected?.isCreate) {
      try {
        const res = await api.post(apiUrl + "Category/create", {
          name: selected.rawName
        });

        debugger;
        const newCategory = {
          label: res.data.data.name,
          value: res.data.data.id
        };

        // kategori listesine ekle
        setCategories(prev => [...prev, newCategory]);
        setCategory(newCategory);

        toast.current?.show({
          severity: "success",
          summary: "Kategori eklendi",
          detail: `"${newCategory.label}" oluşturuldu`,
          life: 2000
        });
      } catch (err) {
        toast.current?.show({
          severity: "error",
          summary: "Hata",
          detail: "Kategori eklenemedi",
          life: 3000
        });
      }

      return;
    }

    // normal seçim
    setCategory(selected);
  }}
/>

              </div>

              <div className="field-item">
                <label className="field-label">Etiketler</label>
                <InputText value={tags} onChange={(e) => setTags(e.target.value)} />
              </div>
              <div className="field-item">
                <label className="field-label">Durum</label>
                <Dropdown
                  value={recordStatus}
                  options={[
                    { label: 'Aktif', value: 1 },
                    { label: 'Pasif', value: 0 }
                  ]}
                  onChange={(e) => setRecordStatus(e.value)}
                  placeholder="Seçiniz"
                  className="w-full"
                />
              </div>
               <div className="field-item">
                <label className="field-label">Açıklama</label>
                <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} />
              </div>
            </div>

            {/* 2. BÖLÜM */}
            <div className="section-box">

              <div className="section-header"><i className="pi pi-wallet"></i> Fiyat & KDV</div>

              <div className="field-item">
                <label className="field-label">Satış Fiyatı</label>
                <InputNumber
                  value={salePrice}
                  onValueChange={(e) => {
                    setSalePrice(e.value);
                    recalcVatValues(e.value, taxRate, salePriceIsVatIncluded);
                  }}
                  mode="currency"
                  currency="TRY"
                  locale="tr-TR"
                /> 
              </div> 
             <div
  className={`mt-3 mb-3 p-3 rounded-xl border flex items-center justify-between transition-all
    ${salePriceIsVatIncluded
      ? "!bg-emerald-50 border-emerald-200 dark:!bg-emerald-950/20 dark:border-emerald-800/40"
      : "!bg-blue-50 border-blue-200 dark:!bg-blue-950/20 dark:border-blue-800/40"}`}
>
  <div className="flex items-center gap-3">
    <i
      className={`pi ${
        salePriceIsVatIncluded ? "pi-check-circle text-emerald-600 dark:text-emerald-400" : "pi-calculator text-blue-600 dark:text-blue-400"
      } text-xl`}
    />
    <div>
      <div className={`text-sm font-black ${
        salePriceIsVatIncluded ? "text-slate-800 dark:text-emerald-300" : "text-slate-800 dark:text-blue-300"
      }`}>
        {salePriceIsVatIncluded ? "KDV Dahil Fiyat" : "KDV Hariç Fiyat"}
      </div>
      <div className={`text-xs ${
        salePriceIsVatIncluded ? "text-slate-500 dark:text-emerald-400/70" : "text-slate-500 dark:text-blue-400/70"
      }`}>
        {salePriceIsVatIncluded
          ? "Girilen fiyat KDV içerir"
          : "KDV sonradan hesaplanır"}
      </div>
    </div>
  </div>

  <Checkbox
    checked={salePriceIsVatIncluded}
    onChange={(e) => {
      setSalePriceIsVatIncluded(e.checked);
      recalcVatValues(salePrice, taxRate, e.checked);
    }}
  />
</div>

              <div className="field-item">
                <label className="field-label">KDV Oranı</label>
                <InputNumber
                  value={taxRate}
                  onValueChange={(e) => {
                    setTaxRate(e.value);
                    recalcVatValues(salePrice, e.value, salePriceIsVatIncluded);
                  }}
                  suffix="%"
                />
              </div>
{/* 🔔 SON ALIŞ BİLGİSİ */}
<div
  className={`section-box ${
    lastPurchase
      ? "product-last-purchase-active"
      : "product-last-purchase-inactive"
  }`}
  style={{ borderStyle: "dashed" }}
>
  <div className="section-header">
    <i className="pi pi-history"></i> Son Alış Bilgisi
  </div>

  {lastPurchase ? (
    <div style={{ fontSize: ".85rem", lineHeight: 1.6 }}>
      <div>
        <b>Tedarikçi:</b>{" "}
        <span className="text-blue-600 dark:text-indigo-400 font-semibold">
          {lastPurchase.supplierName}
        </span>
      </div>

      <div>
        <b>Alış Tarihi:</b>{" "}
        {new Date(lastPurchase.purchaseDate).toLocaleString("tr-TR")}
      </div>

      <div>
        <b>Birim Fiyat:</b>{" "}
        <span style={{ fontWeight: 700 }}>
          {lastPurchase.unitPrice.toLocaleString("tr-TR", {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          })} ₺
        </span>
      </div>
    </div>
  ) : (
    <div
      className="text-slate-500 dark:text-slate-400 flex items-center gap-2 italic text-[13px]"
    >
      <i className="pi pi-info-circle text-blue-400"></i>
      Henüz bu ürün için alış kaydı girilmemiştir.
    </div>
  )}
</div>

             <div className="grid grid-cols-2 gap-3 mt-4">
  {/* KDV HARİÇ */}
  <div
    className={`p-3 rounded-xl border transition-all ${
      !salePriceIsVatIncluded
        ? "supplier-card-blue shadow"
        : "supplier-card-slate"
    }`}
  >
    <div className={`text-[10px] font-black uppercase tracking-widest ${
      !salePriceIsVatIncluded
        ? "text-blue-600 dark:text-blue-400/80"
        : "text-slate-500 dark:text-slate-400"
    }`}>
      KDV Hariç
    </div>
    <div className="text-lg font-black text-slate-800 dark:text-white mt-1">
      {calcExclVat?.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5
      })} ₺
    </div>
 
  </div>

  {/* KDV DAHİL */}
  <div
    className={`p-3 rounded-xl border transition-all ${
      salePriceIsVatIncluded
        ? "supplier-card-emerald shadow"
        : "supplier-card-slate"
    }`}
  >
    <div className={`text-[10px] font-black uppercase tracking-widest ${
      salePriceIsVatIncluded
        ? "text-emerald-600 dark:text-emerald-400/80"
        : "text-slate-500 dark:text-slate-400"
    }`}>
      KDV Dahil (%{taxRate})
    </div>
    <div className="text-lg font-black text-slate-800 dark:text-white mt-1">
      {calcInclVat?.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5
      })} ₺
    </div>
 
  </div>
</div>

              {/* Çoklu Fiyat Seviyeleri */}
              <div className="mt-3 p-2 bg-slate-100 border-t border-slate-200 dark:border-slate-700">
                <h3 className="text-sm font-bold text-slate-800 dark:text-slate-200 mb-3 flex items-center gap-2">
                  <i className="pi pi-tags !text-indigo-500"></i>
                  Çoklu Fiyat Seviyeleri
                </h3>
                <div className="flex flex-col gap-3">
                  {priceTiers.map(tier => {
                    const priceVal = tierPrices[tier.id]?.priceInclVat ?? null;
                    const priceExcl = priceVal ? priceVal / (1 + taxRate / 100) : 0;
                    return (
                      <div key={tier.id} className="p-3 bg-slate-300 dark:bg-slate-800/40 rounded-xl border border-slate-100 dark:border-slate-800/60 flex items-center justify-between gap-4">
                        <div className="flex-1">
                          <div className="text-s font-bold text-slate-700 dark:text-slate-300">{tier.name}</div>
                          {tier.description && <div className="text-[10px] text-slate-400 mt-0.5">{tier.description}</div>}
                        </div>
                        <div className="w-48">
                          <InputNumber
                            value={priceVal}
                            onValueChange={(e) => {
                              setTierPrices(prev => ({
                                ...prev,
                                [tier.id]: { priceInclVat: e.value }
                              }));
                            }}
                            mode="currency"
                            currency="TRY"
                            locale="tr-TR"
                            placeholder="0"
                            className="w-full"
                            inputClassName="w-full text-right font-semibold"
                          />
                          {priceVal > 0 && (
                            <div className="text-[9px] text-right text-slate-400 mt-1">
                              KDV Hariç: {priceExcl.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {priceTiers.length === 0 && (
                    <div className="text-xs text-slate-400 italic flex items-center gap-1.5">
                      <i className="pi pi-info-circle"></i>
                      Tanımlı fiyat seviyesi bulunamadı. Ayarlar menüsünden fiyat seviyesi ekleyebilirsiniz.
                    </div>
                  )}
                </div>
              </div>

            </div>

            {/* 3. BÖLÜM */}
            <div className="section-box">
              <div className="section-header"><i className="pi pi-cog"></i> Diğer Bilgiler</div> 
              <div className="field-item">
                <label className="field-label">Anlık Stok</label>
                <InputNumber
                  value={currentStockQuantity}
                  onValueChange={(e) => setCurrentStockQuantity(e.value)}
                />
              </div>
              <div className="field-item">
                <label className="field-label">Kritik Stok</label>
                <InputNumber
                  value={criticalStockQuantity}
                  onValueChange={(e) => setCriticalStockQuantity(e.value)}
                />
              </div>
              <div className="field-item">
                <label className="field-label">Barkod</label>
                <InputText value={barcode} onChange={(e) => setBarcode(e.target.value)} />
              </div>
              <div className="field-item">
                <label className="field-label">Son Kullanma Tarihi Takibi</label>
                <div className="flex align-items-center">
                  <Checkbox
                    checked={trackExpirationDate}
                    onChange={(e) => setTrackExpirationDate(e.checked)}
                  />
                  <span className="text-slate-700 dark:text-slate-300 font-semibold" style={{ marginLeft: 8 }}>Evet, SKT takibi yapılsın</span>
                </div>
              </div>
              <div className="field-item">
  <label className="field-label">
    Satış Birimi <span style={{ color: "#94a3b8", fontWeight: 500 }}></span>
  </label>

  <AutoComplete
     value={unitType}
    suggestions={filteredUnitTypes}
    completeMethod={searchUnitType}
    onChange={(e) => setUnitType(e.value)}
    field="label"
    dropdown
    appendTo={document.body}
    placeholder="Birim seçiniz..." 
  />

  <small style={{ color: "#64748b", marginTop: 6 }}>
    Örn: Un → kg · Zeytinyağı → lt · Çikolata → adet
  </small>
</div> 
{/*
              <div className="field-item">
                <label className="field-label">Birim (Paket İçerisindeki Miktar Örn:Tablet 500mg)</label>
                <InputText value={unit} onChange={(e) => setUnit(e.target.value)} />
              </div>

              <div className="field-item">
                <label className="field-label">Birim Tipi</label>
                <AutoComplete
                  value={unitType}
                  suggestions={filteredUnitTypes}
                  completeMethod={searchUnitType}
                  onChange={(e) => setUnitType(e.value)}
                  field="label"
                  dropdown
                />
              </div>*/
}
           {(() => {
  const current = Number(currentStockQuantity ?? 0);
  const critical = Number(criticalStockQuantity ?? 0);
  const isLow = critical > 0 && current <= critical;
  const unitLabel = unitType?.label || "";  

  return (
    <div
      className={`p-4 rounded-xl mb-4 border border-dashed transition-all ${
        isLow ? "product-stock-low" : "product-stock-active"
      }`}
    >
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-2 font-bold text-slate-800 dark:text-slate-200">
          <i className="pi pi-chart-bar text-indigo-500 dark:text-indigo-400"></i>
          Stok Bilgisi
        </div>

        <span
          className={`text-xs font-extrabold px-3 py-1 rounded-full transition-all ${
            isLow ? "product-stock-badge-low" : "product-stock-badge-normal"
          }`}
        >
          {isLow ? "Kritik" : "Normal"}
        </span>
      </div>

      <div className="text-3xl font-black text-slate-900 dark:text-white flex items-baseline">
        {current.toLocaleString("tr-TR")}
        {unitLabel && (
          <span className="text-sm font-bold text-slate-500 dark:text-slate-400 ml-2">
            {unitLabel}
          </span>
        )}
      </div>

      <div className="text-xs text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Kritik seviye: <span className="font-bold text-slate-700 dark:text-slate-300">{critical.toLocaleString("tr-TR")}</span>
        {unitLabel ? ` ${unitLabel}` : ""}
      </div>
    </div>
  );
})()}

             
            </div>

          </div>

        </form>

        <Dialog
          header="Açık Faturalar Mevcut"
          visible={showWarningDialog}
          style={{ width: '450px' }}
          modal
          onHide={() => setShowWarningDialog(false)}
          footer={
            <div className="flex justify-content-end gap-2">
              <Button label="Evet" icon="pi pi-check" className="p-button-success" onClick={() => {
                setShowWarningDialog(false);
                setShowInvoicesDialog(true);
              }} />
              <Button label="Hayır" icon="pi pi-times" className="p-button-warning" onClick={handleUpdateProductOnly} />
              <Button label="İptal" icon="pi pi-undo" className="p-button-secondary p-button-text" onClick={() => setShowWarningDialog(false)} />
            </div>
          }
        >
          <div className="flex align-items-center gap-3">
            <i className="pi pi-exclamation-triangle text-amber-500 text-3xl" />
            <span style={{ fontSize: "1.05rem", lineHeight: "1.5" }}>
              Satış fiyatı değişen ürün için açık faturalar mevcut. Açık faturaların içerisindeki ürünün satış fiyatını güncellemek ister misiniz?
            </span>
          </div>
        </Dialog>

        <Dialog
          header="Açık Faturaları Güncelle"
          visible={showInvoicesDialog}
          style={{ width: '700px' }}
          modal
          onHide={() => setShowInvoicesDialog(false)}
          footer={
            <div className="flex justify-content-between align-items-center w-full">
              <Button label="Yalnızca Ürünü Güncelle" className="p-button-text p-button-warning" onClick={handleUpdateProductOnlyFromList} />
              <div className="flex gap-2">
                <Button label="Seçilenleri Güncelle ve Kaydet" icon="pi pi-check" className="p-button-success" onClick={handleUpdateWithInvoices} />
                <Button label="Vazgeç" icon="pi pi-times" className="p-button-secondary" onClick={() => setShowInvoicesDialog(false)} />
              </div>
            </div>
          }
        >
          <div className="mb-3">
            <p className="text-slate-600 dark:text-slate-400 text-sm">
              Ürünün satış fiyatını <b>({(salePriceIsVatIncluded ? salePrice : (salePrice * (1 + taxRate / 100)))?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺)</b> güncellemek istediğiniz faturaları seçiniz:
            </p>
          </div>
          
          <div className="border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden max-h-96 overflow-y-auto">
            <table className="w-full text-left border-collapse text-sm">
              <thead>
                <tr className="bg-slate-50 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold border-b border-slate-200 dark:border-slate-700">
                  <th className="p-3 w-16 text-center">
                    <Checkbox 
                      checked={openInvoices.length > 0 && selectedInvoices.length === openInvoices.length} 
                      onChange={handleToggleAll} 
                    />
                  </th>
                  <th className="p-3">Müşteri Adı</th>
                  <th className="p-3">Fatura No</th>
                  <th className="p-3">Fatura Tarihi</th>
                  <th className="p-3 text-right">Eski Fiyat</th>
                  <th className="p-3 text-right">Miktar</th>
                </tr>
              </thead>
              <tbody>
                {openInvoices.map((inv) => (
                  <tr 
                    key={inv.saleId} 
                    className="border-b border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50 cursor-pointer"
                    onClick={() => handleToggleInvoice(inv.saleId)}
                  >
                    <td className="p-3 text-center" onClick={(e) => e.stopPropagation()}>
                      <Checkbox 
                        checked={selectedInvoices.includes(inv.saleId)} 
                        onChange={() => handleToggleInvoice(inv.saleId)} 
                      />
                    </td>
                    <td className="p-3">
                      <div className="font-semibold text-slate-800 dark:text-slate-200">{inv.customerName}</div>
                      {inv.isCustomPrice && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-purple-100 text-purple-800 dark:bg-purple-950/40 dark:text-purple-300 mt-1">
                          <i className="pi pi-star-fill text-[8px]"></i> Özel Fiyatla Satıldı
                        </span>
                      )}
                    </td>
                    <td className="p-3 text-slate-600 dark:text-slate-400">{inv.saleNo || inv.saleId}</td>
                    <td className="p-3 text-slate-500">{new Date(inv.saleDate).toLocaleDateString('tr-TR')}</td>
                    <td className="p-3 text-right">
                      <div className="font-medium text-slate-800 dark:text-slate-200">
                        {inv.currentProductUnitPrice?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                      </div>
                      {inv.isCustomPrice && (
                        <span className="text-[10px] text-purple-600 dark:text-purple-400 font-semibold block mt-0.5">
                          Müşteri Özel Fiyatı
                        </span>
                      )}
                    </td>
                    <td className="p-3 text-right text-slate-600 dark:text-slate-400">
                      {inv.quantity?.toLocaleString('tr-TR')}
                    </td>
                  </tr>
                ))}
                {openInvoices.length === 0 && (
                  <tr>
                    <td colSpan="6" className="p-4 text-center text-slate-500 italic">Açık fatura bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="mt-3 flex justify-content-between text-xs text-slate-500">
            <span>Toplam {openInvoices.length} fatura listelendi</span>
            <span>{selectedInvoices.length} fatura seçildi</span>
          </div>
        </Dialog>
      </Card>
    </>
  );
}
